// extracted by css-extract-rspack-plugin
export default {"DataBucketList":"oMCRT","DataBucketListItemTitle":"JeELN","DataBucketListItemDescription":"A9DD1","DataBucketListItemIcon":"QxneU","DataBucketListItemContainer":"q3JJ0"};